<template>
  <v-app>
    <div class="fixed-top">
     <b-navbar toggleable="lg" type="light" variant="light" style="height:auto;">  
       <b-navbar-brand><img src="../../assets/headlogo.png" style="width:200px;cursor: pointer;" @click="main()"/></b-navbar-brand>
       
       <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

       <b-collapse id="nav-collapse" is-nav>
         <b-navbar-nav>
         </b-navbar-nav>

         <b-navbar-nav class="ml-auto mr-5">
           <b-nav-item @click="vendor()">
             Vendor Registration
           </b-nav-item>
           <!-- <b-nav-item-dropdown text="Categories">
          <b-dropdown-item href="#">Restaurant Equipment</b-dropdown-item>
          <b-dropdown-item href="#">Commercial Refrigeration</b-dropdown-item>
          <b-dropdown-item href="#">Commercial Sinks</b-dropdown-item>
          <b-dropdown-item href="#">Kitchen Supplies</b-dropdown-item>
        </b-nav-item-dropdown> -->
           <b-nav-item style="margin-top:-10px" @click="dashboard()" v-if="loggedInUserID != null">
             <v-icon :size="30">person_outline</v-icon>My Account
           </b-nav-item>
           <b-nav-item style="margin-top:-10px" @click.stop="logDialog = true" v-if="loggedInUserID == null">
             <v-icon :size="30">lock_open</v-icon>Login / Registration
           </b-nav-item>
           <b-nav-item style="margin-top:-10px" @click="cartList()" v-if="$store.state.cartCount > 0">
             <v-badge
        color="red"
        right
        overlap
        size="0.2px"
      >
        <span slot="badge">{{$store.state.cartCount}}</span>
        <v-btn icon class="ma-0">
          <v-icon @click="notify()"
          >
            add_shopping_cart
          </v-icon>
         </v-btn>
      </v-badge>
             Shopping Cart
           </b-nav-item>
           <b-nav-item style="margin-top:-10px" @click="cartList()" v-if="$store.state.cartCount == 0">
             
        <v-btn icon class="ma-0">
          <v-icon @click="notify()"
          >
            add_shopping_cart
          </v-icon>
         </v-btn>
             Shopping Cart
           </b-nav-item>
         </b-navbar-nav>


       </b-collapse>
     </b-navbar>
     <div>
       <v-tabs
      v-model="tab"
      grow
      >
      <v-tab
        style="background-color:#212121;border:2px solid;color:white;border-color:#e53935"
        v-for="item in categoryList"
        :key="item.id"
      >{{item.categoryName}}
      </v-tab>
      </v-tabs>
     </div>
     </div>
     
       
    
  <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
    </v-content>



    <v-dialog v-model="logDialog" lazy width="350px">
      <v-card style="border-radius:0px;background-color:#212121" flat>
        <v-container>
          <h5 class="white--text" style="text-align:center">Login & Registration</h5>

          <div style="text-align:center;padding-top:25px">
            <v-btn depressed small color="#e53935" dark @click="register()">REGISTRATION</v-btn>
            <v-btn depressed small color="#e53935" dark @click="login()">LOGIN</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
   
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
import config from "./../../config.json";
//import vuetifyToast from "vuetify-toast";
//import { AuthStr } from "../Auth.js";
/* import carousel from 'vue-owl-carousel'; */
const DEFAULT_TRANSITION = "fade";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      tab: null,
      valid: true,
      passwordShow: false,
      menu: false,
      darkMode: false,
      dateModel: false,
      enquiryDialog: false,
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      transitionName: DEFAULT_TRANSITION,
      isLoading: false,
      destinations: null,
      selectedDestination: null,
      logDialog: false,
      btnSave: false,
      src: "https://aimroindia.com/aimro/api/ProfilePic/" + sessionStorage.loggedInUserID,

      homeB: true,
      aboutB: false,
      activityB: false,
      centreB: false,
      teacherB: false,
      partnerB: false,

      form: {
        email: null
      },

      categoryList: [],

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },

    };
  },
  methods: {

    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/wanderlusters");
        window.location.reload();
      });
    },

    main() {
      this.$router.push("/polymac");
    },
    
    login() {
      this.$router.push("/login");
    },
    cartList() {
      this.$router.push("/cartList");
    },

    dashboard() {
      this.$router.push("/_");
    },

    vendor() {
      this.$router.push("/vendorRegistration");
    },

    register() {
      this.$router.push("/registration");
    },

    home() {
      this.$router.push("/wings");
      this.aboutB = false;
      this.activityB = false;
      this.centreB = false;
      this.teacherB = false;
      this.partnerB = false;
      this.homeB = true;
    },

    about() {
      this.$router.push("/aboutus");
      this.homeB = false;
      this.activityB = false;
      this.centreB = false;
      this.teacherB = false;
      this.partnerB = false;
      this.aboutB = true;
    },

  },

  mounted() {
    this.axios
        .get(config.API + "MenuCategories", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categoryList = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
  },

  created() {

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');
@import url('https://fonts.googleapis.com/css?family=Farro&display=swap');  
@keyframes blink {
  from { background-color: purple; }
  to { background-color: red; }
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.header-top {
    background-color: green;
    color: #fff;
    width: 100%;
    padding: 6px;
    /* margin-bottom: 5px; */
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.menutxt {
  padding-right: 10px;
  font-family: 'Special Elite', cursive;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  margin-bottom: 0px;
}
.footertxt {
  font-family: 'Nanum Gothic', sans-serif;
  color: white !important;
  font-size: 16px;
}
.hq {
  border-style: solid;
    border-width: 1px;
    border-radius: .5rem;
    margin-left: .5rem;
    padding: .125rem .5rem;
    font-size: 12px !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: 'Anton', sans-serif;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
 /* background-color: #eeeeee; */
}
.yellowText {
    color: yellow;
}
.font12 {
    font-size: 12px;
    line-height: 12px;
}
.latoBold {
    font-weight: 700;
}
.sprite.discountIcon {
    width: 38px;
    height: 17px;
    background-position: -206px -73px;
}
.appendLeft5 {
    margin-left: 5px;
}
.sprite {
    background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
    display: inline-block;
    background-size: 400px 400px;
    font-size: 0px;
    flex-shrink: 0;
}
.font11 {
    font-size: 11px;
    line-height: 11px;
}
.discountText {
    display: inline-block;
    position: absolute;
    left: 12px;
    top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.sign {
  color:white !important;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
.flashing_effect {
  background-image: linear-gradient(-90deg, #f44336, #b32e25);
  padding: 12px 15px;
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.abc {
  overflow: hidden !important;
}
.ftr {
  /* background-image: url('../../assets/footer.png'); */
  background-color: #333333;
  background-size: cover !important;
}
</style>
